import { MessageEl } from './MessageEl';
import { NavigateButton } from './NavigateButton';

export const seCeErrors = (jobId?: string) => ({
  DEFAULT: {
    title: 'Account setup unsuccessful',
    message: (
      <MessageEl
        preText="For assistance, please contact support:"
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INVALID_INPUT: {
    title: 'Account setup unsuccessful',
    message: (
      <MessageEl
        preText="For assistance, please contact support:"
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  INTERNAL_ERROR: {
    title: 'Account setup unsuccessful',
    message: (
      <MessageEl
        preText="For assistance, please contact support:"
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  EMAIL_ALREADY_IN_USE: {
    title: 'Unable to use email address',
    message: (
      <MessageEl
        preText="The Amazon Seller email address entered is either invalid or already associated with a Veeqo account. Please try signing in to Veeqo."
        jobId={jobId}
      />
    ),
    rightActions: [<NavigateButton href="https://app.veeqo.com/signin" text="Sign in to Veeqo" />],
  },
  INSUFFICIENT_PERMISSIONS: {
    title: 'Account setup unsuccessful',
    message: (
      <MessageEl
        preText="Your Amazon Seller account doesn't have sufficient permissions to set up Veeqo. Please ask the Amazon Seller account owner to set up Veeqo."
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MULTIPLE_STORE_COLLECTION: {
    title: 'Account setup unsuccessful',
    message: (
      <MessageEl
        preText="For assistance, please contact support:"
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  STORE_CONNECTION_ERROR: {
    title: 'Amazon store connection failed',
    message: (
      <MessageEl
        preText="The Amazon store could not be connected. Please sign in to Veeqo and try again."
        jobId={jobId}
      />
    ),
    rightActions: [<NavigateButton href="https://app.veeqo.com/signin" text="Sign in to Veeqo" />],
  },
  STORE_ALREADY_IN_USE: {
    title: 'Amazon store already connected',
    message: (
      <MessageEl
        preText="Your Amazon store is already connected to a Veeqo account. For assistance, please contact support:"
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MISSING_MERCHANT_ADDRESS: {
    title: 'Merchant address missing',
    message: (
      <MessageEl
        preText="The merchant address is missing from your Amazon Seller account. Please add a valid address in your Amazon Seller account settings."
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  MISSING_MERCHANT_NAME: {
    title: 'Merchant address missing',
    message: (
      <MessageEl
        preText="The merchant name is missing from your Amazon Seller account. Please add a valid name in your Amazon Seller account settings."
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  OWNER_STILL_ONBOARDING: {
    title: 'Account setup already started',
    message: (
      <MessageEl
        preText="This Amazon Seller account has already started creating a Veeqo account. Please wait for the setup to complete. If you need assistance, please contact support:"
        linkText="helpme@support.veeqo.com"
        href="mailto:helpme@support.veeqo.com"
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
  ACCOUNT_ALREADY_LINKED: {
    title: 'Veeqo account already linked',
    message: (
      <MessageEl
        preText="Veeqo is already set up for this Amazon Seller account. Please ask the account owner to add you as a user in Veeqo."
        jobId={jobId}
      />
    ),
    rightActions: [],
  },
});
